export interface NavCategory {
  id: string;
  name: string;
  icon: string;
  description: string;
  children: { id: string; name: string }[];
}

export const categories: NavCategory[] = [
  {
    id: "life",
    name: "生活服务",
    icon: "ri-home-smile-2-line",
    description: "便民生活、出行查询、政务办事与健康医疗，日常琐事一站搞定。",
    children: [
      { id: "life-travel", name: "出行" },
      { id: "life-service", name: "便民" },
      { id: "life-health", name: "健康" },
    ],
  },
  {
    id: "shopping",
    name: "购物电商",
    icon: "ri-shopping-bag-3-line",
    description: "综合电商、特卖折扣与本地生活，比价下单更省时间。",
    children: [
      { id: "shopping-mall", name: "综合商城" },
      { id: "shopping-deal", name: "折扣特卖" },
      { id: "shopping-local", name: "本地生活" },
    ],
  },
  {
    id: "entertainment",
    name: "影音娱乐",
    icon: "ri-play-circle-line",
    description: "长视频、短视频、音乐与直播，热门内容随时开看。",
    children: [
      { id: "entertainment-video", name: "视频" },
      { id: "entertainment-music", name: "音乐" },
      { id: "entertainment-live", name: "直播" },
    ],
  },
  {
    id: "study",
    name: "学习教育",
    icon: "ri-book-open-line",
    description: "公开课、考试题库、语言学习与知识社区，学习路径更清晰。",
    children: [
      { id: "study-course", name: "公开课" },
      { id: "study-exam", name: "考试题库" },
      { id: "study-language", name: "语言学习" },
    ],
  },
  {
    id: "office",
    name: "办公工具",
    icon: "ri-briefcase-4-line",
    description: "文档协作、云端存储与效率工具，让办公流程更顺手。",
    children: [
      { id: "office-doc", name: "文档协作" },
      { id: "office-storage", name: "云存储" },
      { id: "office-efficiency", name: "效率" },
    ],
  },
  {
    id: "news",
    name: "新闻资讯",
    icon: "ri-newspaper-line",
    description: "综合新闻、财经科技与深度媒体，第一时间掌握动态。",
    children: [
      { id: "news-general", name: "综合新闻" },
      { id: "news-tech", name: "科技财经" },
    ],
  },
  {
    id: "social",
    name: "社交社区",
    icon: "ri-chat-3-line",
    description: "社交平台、兴趣社区与问答论坛，找到同频的人。",
    children: [
      { id: "social-platform", name: "社交平台" },
      { id: "social-forum", name: "兴趣社区" },
    ],
  },
  {
    id: "tech",
    name: "编程开发",
    icon: "ri-code-s-slash-line",
    description: "代码托管、开发文档与设计资源，开发者常用入口合集。",
    children: [
      { id: "tech-code", name: "代码托管" },
      { id: "tech-docs", name: "技术文档" },
      { id: "tech-design", name: "设计素材" },
    ],
  },
  {
    id: "travel",
    name: "旅游出行",
    icon: "ri-flight-takeoff-line",
    description: "机票酒店、地图导航与游记攻略，出行前先查这里。",
    children: [
      { id: "travel-ticket", name: "机票酒店" },
      { id: "travel-map", name: "地图导航" },
      { id: "travel-guide", name: "攻略游记" },
    ],
  },
  {
    id: "finance",
    name: "金融理财",
    icon: "ri-line-chart-line",
    description: "银行支付、基金股票与记账工具，守住每一笔钱。",
    children: [
      { id: "finance-bank", name: "银行支付" },
      { id: "finance-invest", name: "基金股票" },
    ],
  },
];

export const getCategoryById = (id: string) =>
  categories.find((item) => item.id === id);